import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PackageData } from "../../types/callPackage";
import { useCart } from "../../hooks/useCart";
import {
  setClickedCartId,
  setFromDeleteService,
  setModelTitle,
} from "../../store/slices/IdSlice";
import { useLocation } from "react-router-dom";
import { setPackageAndServiceModelTrue } from "../../store/slices/modalSlice";

interface Props {
  hide?: boolean;
  isDelete?: boolean;
}

const CartPackage: React.FC<Props> = ({ hide, isDelete = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { getData, cartRedirect } = useCart();
  const CartItems = useSelector(
    (state: { ID: { CartItems: PackageData } }) => state.ID.CartItems
  );
  const totalAmount = useSelector(
    (store: { ID: { cartValuePrice: number } }) => store.ID.cartValuePrice
  );

  const viewOpenandClose = useSelector(
    (store: { ID: { viewOpenandClose: any[] } }) => store.ID.viewOpenandClose
  );

  const handleToggle = (clickedCartId: number) => {
    OpenModel(clickedCartId, "Package");
  };

  const OpenModel = (clickedCartId: number, title?: string) => {
    dispatch(setModelTitle(title));
    dispatch(setClickedCartId(clickedCartId));
    dispatch(setPackageAndServiceModelTrue());
  };

  useEffect(() => {
    import("./CartPackage.css");
    const packageLength = CartItems?.packages?.length || 0;
    const serviceLength = CartItems?.services?.length || 0;


    if (packageLength === 0 && serviceLength === 0) {
      getData();
    }
  }, []);

  return (
    <>
      {CartItems?.packages?.length === 0 &&
      CartItems?.services?.length === 0 ? (
        <>
          <div className="card m-b-32">
            <div className="card-body add-cart-each">
              <div className="d-flex fle justify-content-center align-items-center">
                <div className=" mb-3">
                  <img
                    loading="lazy"
                    src="https://goodhand.b-cdn.net/Assets/cart/cart-empty.svg"
                    alt="No img"
                    className="d-block mx-auto my-3"
                    style={{ height: "115px" }}
                  />
                  <p className="text-black font-13 ff-bold text-center mb-1">
                    Your cart feels a bit light
                  </p>

                  <p className="font-10 text-dark ff-normal">
                    There are no services in it yet. Let's add some fantastic
                    services
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="card mb-3 add-cart-main p-0">
          <div className="bg-2 px-3 py-2 mb-0 d-flex align-items-center gap-2">
            <img
              src="https://goodhand.b-cdn.net/Assets/Upload/cart-bag.svg"
              alt=""
              className="img-fluid"
              style={{ height: "20px" }}
            />
            <div className="font-14 text-black ff-semibold ">Cart Overview</div>
            <div className="hd-style-3 px-2 d-none">
              3 <span className="font-12"> Services </span>
            </div>
          </div>
          <div
            className="card mb-3 add-cart-each border-bottom-0 "
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            {/* First Cart Item */}
            <div className="card-body1 p-4 pt-2 pb-0">
              <div>
                {CartItems?.packages?.map((packageItem) => {
                  const isItemOpen = () => {
                    const match = viewOpenandClose.find(
                      (item) => item.cartId === packageItem.cartId
                    );
                    return match ? match.isChecked === true : false;
                  };

                  return (
                    <div
                      className="position-relative border-bottom pb-1 mb-2"
                      key={packageItem.cartId}
                    >
                      <div className="d-flex justify-content-between align-items-center gap-1 mb-1">
                        <div className="product-name">
                          <p className="checkout-ser-name font-12 mb-0 ff-medium text-black">
                            {/* Parent Visa Package */}
                            {packageItem?.packageName}
                          </p>
                        </div>
                        <div style={{ width: "30%" }}>
                          <span className="main-price pt-1 ff-bold text-end d-block font-13">
                            <span className="ff-currency font-15 ff-medium">
                              
                            </span>
                            {packageItem?.totalPrice.toFixed(2)}
                          </span>
                        </div>
                        {isDelete && (
                          <div
                            className="d-flex flex-column align-items-center justify-content-center bg-light-red rounded-2 cursor-pointer"
                            style={{ height: "25px", width: "25px" }}
                          >
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                handleToggle(packageItem?.cartId);
                                dispatch(setFromDeleteService(true));
                              }}
                            >
                              <svg
                                width="14"
                                height="15"
                                viewBox="0 0 11 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 3.26953H10.0764"
                                  stroke="#F52222"
                                  strokeWidth="0.850911"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M4.40234 5.53809V8.94173"
                                  stroke="#F52222"
                                  strokeWidth="0.850911"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M6.67188 5.53809V8.94173"
                                  stroke="#F52222"
                                  strokeWidth="0.850911"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M1.56641 3.26953L2.13368 10.0768C2.13368 10.3777 2.25321 10.6663 2.46598 10.8791C2.67875 11.0918 2.96733 11.2114 3.26823 11.2114H7.80642C8.10732 11.2114 8.3959 11.0918 8.60867 10.8791C8.82144 10.6663 8.94097 10.3777 8.94097 10.0768L9.50825 3.26953"
                                  stroke="#F52222"
                                  strokeWidth="0.850911"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3.83594 3.2691V1.56727C3.83594 1.41682 3.8957 1.27254 4.00209 1.16615C4.10847 1.05977 4.25276 1 4.40321 1H6.67231C6.82276 1 6.96705 1.05977 7.07343 1.16615C7.17982 1.27254 7.23958 1.41682 7.23958 1.56727V3.2691"
                                  stroke="#F52222"
                                  strokeWidth="0.850911"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className="cart-toggle font-12 ff-semibold mb-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleToggle(packageItem?.cartId);
                          dispatch(setFromDeleteService(false));
                        }}
                      >
                        {isItemOpen() ? "Hide Package" : "View Package"}
                      </div>
                      {isItemOpen() && (
                        <div className="cart-details">
                          {packageItem?.selectedFilter?.length > 0 && (
                            <div className="cart-options">
                              <p className="options-title ff-semibold text-black my-2 font-12">
                                Options Selected for visa
                              </p>
                              <div className="options-list d-flex gap-2">
                                {packageItem?.selectedFilter?.map(
                                  (filterData) => (
                                    <span className="option category px-2 py-1 rounded-pill bg-3 text-main">
                                      {filterData}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                          {packageItem?.serviceDetails?.length > 0 && (
                            <div className="cart-services">
                              <p className="options-title ff-semibold text-black my-2 font-12">
                                Service includes
                              </p>
                              {packageItem?.serviceDetails?.map(
                                (serviceDetail) => (
                                  <ul className="services-list-package-main">
                                    <li>{serviceDetail.serviceName}</li>
                                  </ul>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
                {CartItems?.services?.map((serviceItem, index) => (
                  <div
                    key={serviceItem?.cartID || index}
                    className={`position-relative my-2 py-2 ${
                      index !== CartItems.services.length - 1
                        ? "border-bottom"
                        : ""
                    }`}
                  >
                    <div className="d-flex justify-content-between align-items-center gap-1 mb-1">
                      <div className="product-name">
                        <p className="checkout-ser-name font-12 mb-0 ff-medium text-black">
                          {serviceItem.serviceName}
                        </p>
                      </div>
                      <div style={{ width: "30%" }}>
                        <span className="main-price pt-1 ff-bold text-end d-block font-13">
                          <span className="ff-currency font-15 ff-medium">
                            
                          </span>
                          {serviceItem?.PriceAmount?.toFixed(2)}
                        </span>
                      </div>

                      {isDelete && (
                        <div
                          className="d-flex flex-column align-items-center justify-content-center bg-light-red rounded-2 cursor-pointer"
                          style={{ height: "25px", width: "25px" }}
                        >
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              OpenModel(serviceItem.cartID, "Service");
                              dispatch(setFromDeleteService(true));
                            }}
                          >
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 11 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 3.26953H10.0764"
                                stroke="#F52222"
                                strokeWidth="0.850911"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4.40234 5.53809V8.94173"
                                stroke="#F52222"
                                strokeWidth="0.850911"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M6.67188 5.53809V8.94173"
                                stroke="#F52222"
                                strokeWidth="0.850911"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M1.56641 3.26953L2.13368 10.0768C2.13368 10.3777 2.25321 10.6663 2.46598 10.8791C2.67875 11.0918 2.96733 11.2114 3.26823 11.2114H7.80642C8.10732 11.2114 8.3959 11.0918 8.60867 10.8791C8.82144 10.6663 8.94097 10.3777 8.94097 10.0768L9.50825 3.26953"
                                stroke="#F52222"
                                strokeWidth="0.850911"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M3.83594 3.2691V1.56727C3.83594 1.41682 3.8957 1.27254 4.00209 1.16615C4.10847 1.05977 4.25276 1 4.40321 1H6.67231C6.82276 1 6.96705 1.05977 7.07343 1.16615C7.17982 1.27254 7.23958 1.41682 7.23958 1.56727V3.2691"
                                stroke="#F52222"
                                strokeWidth="0.850911"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="cart-toggle ff-semibold"
                      onClick={(e) => {
                        e.stopPropagation();
                        OpenModel(serviceItem.cartID, "Service");
                        dispatch(setFromDeleteService(false));
                      }}
                    >
                      View detail
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Second Cart Item */}
            {/* <div className="card-body1">
            {serviceData.map((serviceItem) => (
              <div className="position-relative" key={serviceItem.cartID}>
                <div className="d-flex justify-content-between align-items-center gap-1 mb-3">
                  <div className="product-name">
                    <p className="checkout-ser-name font-16 mb-0">
                      {serviceItem.serviceName}
                    </p>
                  </div>
                  <div
                    className="d-flex flex-column align-items-center justify-content-center add-cart-btn-main"
                    style={{ height: "5%" }}
                  >
                    <div className="d-flex align-items-center justify-content-center">
                      <button className="bt-mi">-</button>
                      <span className="mx-0.5">
                        <div className="w-8">
                          <div className="numbercontainer">
                            <span className="animated-number">1</span>
                          </div>
                        </div>
                      </span>
                      <button className="bt-plu" disabled>
                        +
                      </button>
                    </div>
                  </div>
                  <div style={{ width: "30%" }}>
                    <span className="main-price pt-1 ff-semibold text-end d-block">
                      AED&nbsp;{serviceItem?.PriceAmount.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div> */}

            {/* View Cart Button */}
          </div>
          {hide && (
            <div className="mb-2 " onClick={cartRedirect}>
              <a
                className="btn btn-primary flow-btn py-2 d-flex justify-content-between align-items-center mt-3  mx-3"
                style={{
                  cursor: "pointer",
                  backgroundColor: "rgb(110, 66, 229)",
                  border: "none",
                }}
              >
                <span className="ff-semibold">
                  <span className="ff-currency ff-medium  font-16"></span>
                  {totalAmount.toFixed(2)}
                </span>
                <span className="font-14 ff-semibold">View Cart</span>
              </a>
            </div>
          )}
          {location.pathname === "/cart" && (
            <div className="form-check d-flex align-items-center custom-checkbox gap-2 bg-2 ms-0 px-2 py-2 rounded-3 ff-medium">
              <input
                className="form-check-input m-0"
                type="checkbox"
                id="avoidCall"
              />
              <label
                className="custom-check-label font-12 mb-0"
                htmlFor="avoidCall"
              >
                Avoid making calls prior to your arrival at the location
              </label>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CartPackage;
